export default "__VITE_ASSET__IzB1deHv__"